import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, filename: String }

  download() {
    if (this.urlValue) {
      // Create a temporary link element to trigger download
      const link = document.createElement('a')
      link.href = this.urlValue
      link.download = this.filenameValue || 'document'
      link.target = '_blank'
      
      // Append to body, click, and remove
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
